<template>
  <el-dialog
    title="三包索赔单打印预览"
    :visible.sync="currentVisible"
    width="900px"
    top="5vh"
    :close-on-click-modal="false"
    class="print-dialog"
  >
    <div class="print-content" ref="printContent">
      <div v-for="(supplierData, index) in printData" :key="index" class="print-page">
        <div class="print-header">
          <h2>{{ supplierData.title }}</h2>
        </div>
        <div class="print-info">
          <span>供应商：{{ supplierData.supplierName }}</span>
          <span>供应商代码：{{ supplierData.supplierCode }}</span>
          <span>执行时间：{{ supplierData.exportTime }}</span>
          <span>编号：{{ supplierData.exportNum }}</span>
        </div>
        <el-table
          :data="supplierData.dataList"
          border
          size="mini"
          :header-cell-style="{ background: '#fff', color: '#000', fontWeight: 'bold' }"
          style="width: 100%"
        >
          <el-table-column prop="serialNumber" label="序号" width="50" align="center" />
          <el-table-column prop="claimStatementNum" label="索赔单号" width="120" align="center" />
          <el-table-column prop="faultPartName" label="零部件名称" min-width="120" />
          <el-table-column prop="faultPartNumber" label="零部件代码" width="100" align="center" />
          <el-table-column prop="faultPartUnit" label="单位" width="50" align="center" />
          <el-table-column prop="replaceNum" label="数量" width="60" align="center" />
          <el-table-column prop="purchasePrice" label="单价" width="80" align="right" />
          <el-table-column prop="responsibilityRatio" label="责任占比" width="80" align="center" />
          <el-table-column prop="materTotalPrice" label="材料费" width="80" align="right" />
          <el-table-column prop="manageTotalPrice" label="管理费" width="70" align="right" />
          <el-table-column prop="freightPrice" label="运费" width="60" align="right" />
          <el-table-column prop="travelPrice" label="差旅费" width="60" align="right" />
          <el-table-column prop="hourTotalPrice" label="工时费" width="60" align="right" />
          <el-table-column prop="tariffPrice" label="关税" width="60" align="right" />
          <el-table-column prop="otherPrice" label="其他" width="60" align="right" />
        </el-table>
        <div class="print-footer">
          <div class="total-row">
            <span>合计</span>
            <span>件</span>
            <span>{{ supplierData.totalReplaceNum }}</span>
            <span></span>
            <span></span>
            <span>{{ formatMoney(supplierData.totalMaterPrice) }}</span>
            <span>{{ formatMoney(supplierData.totalMangerPrice) }}</span>
            <span>{{ formatMoney(supplierData.totalFreightPrice) }}</span>
            <span>{{ formatMoney(supplierData.totalTravelPrice) }}</span>
            <span>{{ formatMoney(supplierData.totalHourTotalPrice) }}</span>
            <span>{{ formatMoney(supplierData.totalTariffPrice) }}</span>
            <span>{{ formatMoney(supplierData.totalOtherPrice) }}</span>
          </div>
          <div class="other-remark">
            <p>其它说明：</p>
            <p>费用合计： {{ formatMoney(supplierData.totalPrice) }}</p>
            <p>备注：鑫源汽车售后服务维修工时单价为98元/小时；此单据收到核对后无异议请在两个工作日内签章回传，逾期视为无异议我司将直接启票执行扣款！</p>
            <p>质量改善部        联系电话：023-64666669       </p>
            <p>制单：     供应商确认：                          部门主管：                   分管领导：                  财务审核：         </p>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handlePrint">打印</el-button>
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    printData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    formatMoney(value) {
      if (value === null || value === undefined) return '0.00';
      return Number(value).toFixed(2);
    },
    handlePrint() {
      const printContent = this.$refs.printContent;
      const newWin = window.open('', '_blank');
      newWin.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>三包索赔单打印</title>
          <style>
            body { font-family: SimSun, sans-serif; font-size: 12px; }
            .print-page { page-break-after: always; padding: 20px; }
            .print-page:last-child { page-break-after: avoid; }
            h2 { text-align: center; font-size: 18px; margin-bottom: 10px; }
            .print-info { display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 12px; }
            table { border-collapse: collapse; width: 100%; margin-bottom: 10px; }
            th, td { border: 1px solid #000; padding: 6px; text-align: center; font-size: 11px; }
            th { background: #fff; font-weight: bold; }
            .total-row td { font-weight: bold; }
            .other-remark p { margin: 5px 0; }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
        </html>
      `);
      newWin.document.close();
      newWin.print();
      newWin.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.print-dialog {
  ::v-deep .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }
}
.print-content {
  .print-page {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    
    .print-header {
      text-align: center;
      margin-bottom: 15px;
      h2 {
        font-size: 18px;
        font-weight: bold;
      }
    }
    
    .print-info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      font-size: 12px;
    }
    
    .print-footer {
      margin-top: 15px;
      
      .total-row {
        display: flex;
        border: 1px solid #000;
        border-top: none;
        td {
          padding: 6px;
          border-right: 1px solid #000;
          text-align: center;
          &:first-child, &:nth-child(2), &:nth-child(3) {
            border-left: none;
          }
          &:nth-child(4), &:nth-child(5) {
            background: #f5f5f5;
          }
        }
      }
      
      .other-remark {
        margin-top: 15px;
        p {
          margin: 8px 0;
          font-size: 12px;
        }
      }
    }
  }
}
.dialog-footer {
  text-align: center;
}
</style>